import { memo, useEffect, useState } from "react";
import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { ownershipOptions } from "../beneficiary.mock";
import { useFormContext } from "@4uhub/lib4uhub";
import { TBeneficiaryForm } from "./beneficiarySchema";
import { useWatch } from "react-hook-form";

export const Checkboxes = memo(() => {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { setValue, control } = useFormContext<TBeneficiaryForm>();

  const ownership = useWatch({
    control,
    name: "ownership",
  });

  const handleChange = (label: string) => {
    setValue("ownership", label);
  };

  useEffect(() => {
    setSelectedId(
      ownershipOptions.find((opt) => opt.label === ownership)?.id ?? null,
    );
  }, [ownership]);

  return (
    <Grid item xs={12}>
      <RadioGroup>
        {ownershipOptions.map((opt) => (
          <FormControlLabel
            key={opt.id}
            label={opt.label}
            sx={{ width: "fit-content" }}
            control={
              <Radio
                checked={selectedId === opt.id}
                onChange={() => handleChange(opt.label)}
              />
            }
          />
        ))}
      </RadioGroup>
    </Grid>
  );
});
